import teras from '@/teras'

import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/components/Home'

import Login from '@/components/Login'
import ContattoProfile from '@/components/Contatto-profile'

import AbstractProfile from '@/components/Abstract-profile'
import AbstractTesto from '@/components/Abstract-testo'
import AbstractAutore from '@/components/Abstract-autore'
import AbstractEoral from '@/components/Abstract-eoral'
import AbstractEtalk from '@/components/Abstract-etalk'
import AbstractEposter from '@/components/Abstract-eposter'
import AbstractEmailprimoautore from '@/components/Abstract-emailprimoautore'

import Download from '@/components/Yo-download'

Vue.use(VueRouter)

var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

const router = new VueRouter({

  mode: mode,
  base: '/abstract-submit-2023/',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { path: '/', name: 'root', meta: { requiresEvent: false, requiresAuth: true }, components:{main: Home  }},
    
    { path: '/home', name: 'home', meta: { requiresAuth: true }, components:{main: Home  } },     
    { path: '/autologin/:contatto/:evento', name: 'autologin', meta: {equiresAuth: true, requiresEvent: true}, components:{main: Home }  }, 
    { path: '/fromadmin/:contatto/:evento', name: 'fromadmin', meta: {equiresAuth: true, requiresEvent: true}, components:{main: Home }  }, 
    { path: '/epa/:contatto/:abstract', name: 'emailprimoautore', meta: {equiresAuth: true, requiresEvent: true}, components:{main: Home }  }, 

    { path: '/login', name: 'login', meta: { nav: true }, components:{main: Login  }, props: {main: true} },

    { path: '/contatto-profile', name: 'contatto.profile', meta: { requiresEvent: true }, components: { main: ContattoProfile } },

    { path: '/abstract-profile', name: 'abstract.profile', meta: { requiresEvent: true, requiresAuth: true }, components: { main: AbstractProfile } },
    { path: '/abstract-testo', name: 'abstract.testo', meta: { requiresEvent: true, requiresAuth: true }, components: { main: AbstractTesto } },
    { path: '/abstract-autore', name: 'abstract.autore', meta: { requiresEvent: true, requiresAuth: true }, components: { main: AbstractAutore } },
    { path: '/abstract-eoral', name: 'abstract.eoral', meta: { requiresEvent: true, requiresAuth: true }, components: { main: AbstractEoral } },
    { path: '/abstract-etalk', name: 'abstract.etalk', meta: { requiresEvent: true, requiresAuth: true }, components: { main: AbstractEtalk } },
    { path: '/abstract-eposter', name: 'abstract.eposter', meta: { requiresEvent: true, requiresAuth: true }, components: { main: AbstractEposter } },
    { path: '/abstract-emailprimoautore', name: 'abstract.emailprimoautore', meta: { requiresEvent: true, requiresAuth: true }, components: { main: AbstractEmailprimoautore } },
   

    
    { path: '/d/:file', name: 'download', meta: { requiresAuth: true }, components:{main: Download} },

    { path: '*', redirect: '/home' } 
  ]


})

/*
Per le prove ed accedere come AMMINISTRATORE
http://localhost:8080/#/fromadmin/E169DE0114ED4658EA6EC2387D03B6A8/23001
http://localhost:8080/#/epa/E169DE0114ED4658EA6EC2387D03B6A8/19EB0063897141323A6C2CCB1C7CC019


*/



router.beforeEach(async (to, from, next) => {
  console.log("beforeEach")
  let error = false
 
  teras.app.drawer = false
  //to.query contiene le variabili passate in modo standard es. ?variabile=valore
  //to.params contiene le variabili passate in vuejs passate in base a routes[]
  console.log("\nbeforeEach \ncheckFirst: "+teras.check.first+"\nfrom: "+from.path+"\nto: "+to.path+"\n\n")
  teras.router.from = from.path
  teras.router.to = to.path

  console.log(to)

  if (!teras.check.first){
    console.log("SONO RICHIESTE LE OPERAZIONI DI PRIMO AVVIO")
    await checkFirst(to)
  }

  if(to.name=="login"){
    console.error("ARRIVO A FARE IL LOGIN")
    //await checkLogin(to.params)
  }

  if(to.name=="autologin" || to.name=="fromadmin" || to.name=="emailprimoautore"){
    console.error("ARRIVO A FARE AUTOLOGIN")
    await autoLogin(to.params, to.name)
    error = true
  }
  
  console.log("AUTH "+teras.app.auth)
  console.log("AND error "+error)
  if (!error && to.matched.some(record => record.meta.requiresAuth) && !teras.check.auth){
    console.log("È RICHIESTO UTENTE E NON È ANCORA VERIFICATO")
    teras.event.emit('checkAuth', from, to)
    error = true
  }

  if(error){
      next(false)
  }else{
      console.log("beforeEach next")
      teras.app.ready = true
      next()
      teras.event.emit('routerChange', to)
  }

})

export default router